export const orderL2Options = [
  {
    id: 'OB1',
    text: 'Outward ',
    value: 'Outward',
    number: '(5)',
    Icon: 'arrow alternate circle left outline',
    gradientvalue: 40,
  },
  {
    id: 'OB2',
    text: 'Inward ',
    value: 'Inward',
    number: '(6)',
    Icon: 'arrow alternate circle right outline',
    gradientvalue: 40,
  },
  {
    id: 'OB3',
    text: 'Reports ',
    value: 'Reports',
    number: '(36)',
    Icon: 'file alternate outline',
    gradientvalue: -10,
  },
];

export const HFCorderL2Options = [
  {
    id: 'OB1',
    text: 'Shipping ',
    value: 'Shipping',
    number: '(5)',
    Icon: 'arrow alternate circle left outline',
    gradientvalue: 40,
  },
  {
    id: 'OB2',
    text: 'Receiving',
    value: 'Receiving',
    number: '(6)',
    Icon: 'arrow alternate circle right outline',
    gradientvalue: 40,
  },
  {
    id: 'OB4',
    text: 'Service Requests',
    value: 'Service Requests',
    number: '(36)',
    Icon: 'check square outline',
    gradientvalue: -10,
  },
];

export const ordersIncomingOptions = [
  {
    id: 'OOB01',
    text: 'Unvault ',
    value: 'Unvault',
    Icon: 'inbox',
    gradientvalue: 40,
  },
  {
    id: 'OOB02',
    text: 'Verify',
    value: 'VerifyOutward',
    Icon: 'check square outline',
    gradientvalue: 40,
  },

  {
    id: 'OOB03',
    text: 'Approve ',
    value: 'ApproveOutward',
    Icon: 'check circle outline',
    gradientvalue: 40,
  },
  {
    id: 'OOB04',
    text: 'Authorized Personnal',
    value: 'AssignPickerOutward',
    Icon: 'hand lizard outline',
    gradientvalue: 40,
  },
  {
    id: 'OOB05',
    text: 'Move',
    value: 'Move',
    Icon: 'dolly flatbed',
    gradientvalue: 40,
  },
  {
    id: 'OOB06',
    text: 'Package ',
    value: 'Package',
    Icon: 'box',
    gradientvalue: 40,
  },
  {
    id: 'OOB07',
    text: 'Billing ',
    value: 'Billing',
    Icon: 'money bill alternate',
    gradientvalue: 40,
  },
];

export const HFCordersIncomingOptions = [
  {
    id: 'OOB01',
    text: 'Customer Request',
    value: 'Customer Request',
    Icon: 'inbox',
    gradientvalue: 40,
  },
  {
    id: 'OOB02',
    text: 'Shipper',
    value: 'Shipper',
    Icon: 'check square outline',
    gradientvalue: 40,
  },

  {
    id: 'OOB03',
    text: 'Pull',
    value: 'Pull',
    Icon: 'check circle outline',
    gradientvalue: 40,
  },
  {
    id: 'OOB04',
    text: 'Shipping Prep',
    value: 'Shipping Prep',
    Icon: 'hand lizard outline',
    gradientvalue: 40,
  },
  {
    id: 'OOB05',
    text: 'Shipping',
    value: 'Shipping',
    Icon: 'dolly flatbed',
    gradientvalue: 40,
  },
];

export const HFCreceivingOption=[
  {
    id: 'OIDYT1',
    text: 'Receiving',
    value: 'Receiving',
    Icon: 'dolly flatbed',
    gradientvalue: 40,
  },
  
]

export const HFCServiceOption=[
  {
    id: 'ORB01',
    text: 'Customer Service Request',
    value: 'Customer Service Request',
    Icon: 'dolly flatbed',
    gradientvalue: 40,
  },
  {
    id: 'ORB02',
    text: 'Assign Task to Personnal',
    value: 'Assign Task to Personnal',
    Icon: 'check square outline',
    gradientvalue: 40,
  },
  {
    id: 'ORB03',
    text: 'Services',
    value: 'Services',
    Icon: 'check circle outline',
    gradientvalue: 40,
  },
  {
    id: 'ORB04',
    text: 'Returning Services',
    value: 'Returning Services',
    Icon: 'chevron circle right',
    gradientvalue: 40,
  },
]

export const ordersOutcomingOptions = [
  {
    id: 'OIDYT1',
    text: 'Inward Return',
    value: 'Inward Request',
    Icon: 'inbox',
    gradientvalue: 40,
  },
  {
    id: 'OIB02',
    text: 'Verify ',
    value: 'Verify',
    Icon: 'check square outline',
    gradientvalue: 40,
  },
  {
    id: 'OIB03',
    text: 'Approve ',
    value: 'Approve',
    Icon: 'check circle outline',
    gradientvalue: 40,
  },
  {
    id: 'OIB04',
    text: 'Authorized Personnal',
    value: 'Picker Assign',
    Icon: 'hand lizard outline',
    gradientvalue: 40,
  },
  {
    id: 'OIB05',
    text: 'Move To Vault ',
    value: 'Move To Vault',
    Icon: 'chevron circle right',
    gradientvalue: 40,
  },
];

// for L3
export const ordersReportOptions = [
  {
    id: 'ORB01',
    text: 'Received',
    value: 'Received',
    number: '',
    Icon: 'check square outline',
    gradientvalue: 40,
  },
  {
    id: 'ORB02',
    text: 'Waiting for Approval',
    value: 'Waiting For Approval',
    number: '',
    Icon: 'clock outline',
    gradientvalue: 40,
  },
  {
    id: 'ORB03',
    text: 'Approved ',
    value: 'Approved',
    number: '',
    Icon: 'thumbs up outline',
    gradientvalue: 40,
  },
  {
    id: 'ORB04',
    text: 'In Progress ',
    value: 'In Progress ',
    number: '',
    Icon: 'hourglass half',
    gradientvalue: 40,
  },
  {
    id: 'ORB05',
    text: 'Ready ',
    value: 'Ready',
    number: '',
    Icon: 'check',
    gradientvalue: 40,
  },
  {
    id: 'ORB06',
    text: 'Delivered ',
    value: 'Delivered',
    number: '',
    Icon: 'clipboard check',
    gradientvalue: 40,
  },
  {
    id: 'ORB07',
    text: 'Returned ',
    value: 'Returned',
    number: '',
    Icon: 'sign-in alternate',
    gradientvalue: 40,
  },
];
